import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../../features/pcr/store/pcr.actions'
import { ClientDataConstants } from '../../../features/clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../../features/user/selectors'
import { ProcedureService } from '../services/procedure.service'
import { setRolePerformingOptions } from '../store/procedure.actions'
import { sort } from '../../../utilities/options.util'

export function* getRolePerformingOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const procedureService = new ProcedureService(serviceId)
  try {
    const rolePerformingResponse: IOptionsResponse = yield call([
      procedureService,
      procedureService.getRolePerformingOptions,
    ])
    const { entity } = rolePerformingResponse
    sort(entity)
    yield put(setRolePerformingOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRolePerformingOptions() error: ${e}`))
  }
}

export function* getRolePerformingOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRolePerformingOptions)
}
